var map = {
	"./alfajores/ERC20": [
		1185,
		17
	],
	"./aurora/ERC20": [
		1186,
		20
	],
	"./auroratest/ERC20": [
		1187,
		23
	],
	"./bsc/ERC20": [
		1188,
		26
	],
	"./bscdev/ERC20": [
		1189,
		31
	],
	"./bsctest/ERC20": [
		1190,
		35
	],
	"./celo/ERC20": [
		1191,
		40
	],
	"./ganache/ERC20": [
		1192,
		43
	],
	"./goerli/ERC20": [
		1193,
		46
	],
	"./rinkeby/ERC20": [
		1194,
		49
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 228;
module.exports = webpackAsyncContext;